import BankAccountsService from "@/api/services/BankAccountsService";

export default {
  async fetchBankAccounts({ commit }) {
    const bankAccounts = await BankAccountsService.getBankAccounts();
    commit("SET_LIST", bankAccounts);
  },
};
